<template>
	
	<!--<div class="flex-bar">-->
		<!--<span class="icon-goback" @click= "goBack()"></span>-->
		<!--<div class="flex-title">-->
			<!--<span class="vt-middle">{{mainTitle}}</span>-->
		<!--</div>-->
	<!--</div>-->
  <div id="normalBar">
    <mt-header :title="title" style="height: 50px">
      <mt-button @click= "goBack()" slot="left">
        <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
      </mt-button>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>
  </div>


</template>

<script>
	export default	 {
		props: ['title','path'],
		computed: {
			mainTitle(){
				return this.title
			}
		},
    methods: {
		goBack () {
		    console.log(this.path)
		    if (this.path === undefined) {
          this.$router.go(-1)
        } else {
		      this.$router.push(this.path)
        }

      }
    }
	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';

	.flex-bar {
		padding: 0 pxToRem(30px);
		background-color: #fff;
		display: flex;
		justify-content: space-around;
		height: pxToRem(100px);
		line-height: pxToRem(100px);
		border-bottom: 1px solid #eee;
	}

	.flex-title {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		background-color: rgba(255,255,255,0.90);
	}
</style>


// WEBPACK FOOTER //
// normalBar.vue?40429700